<template>
  <a-drawer :title="row && row.domain" :visible="visible" :width="720" @close="visible = false">
    <template v-if="row">
      <a-form-model :model="form" layout="vertical">
        <a-form-model-item label="Owner (user_id, 留空=未绑定)">
          <a-input v-model="form.owner_user_id" placeholder="user id 数字" />
        </a-form-model-item>
        <a-form-model-item label="注册到期">
          <!-- a-date-picker 1.7.6 v-model 给 moment 对象，不支持 valueFormat —— save() 内用 .unix() -->
          <a-date-picker v-model="form._expiryDate" style="width:200px" />
          <a-radio-group v-model="form.registrar_source" style="margin-left:16px">
            <a-radio value="manual">manual</a-radio>
            <a-radio value="whois">whois</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Remark">
          <a-input v-model="form.remark" />
        </a-form-model-item>
        <a-form-model-item label="Active">
          <a-switch v-model="form.active" />
        </a-form-model-item>
        <a-button type="primary" @click="save">保存</a-button>
      </a-form-model>

      <a-divider />

      <div class="checks-grid">
        <div v-for="t in checkTypes" :key="t" class="check-card">
          <div class="hdr">
            <strong>{{ t.toUpperCase() }}</strong>
            <a-button size="small" @click="refresh([t])">刷新</a-button>
          </div>
          <health-tag :status="latest[t] ? latest[t].status : 'unknown'" />
          <pre v-if="latest[t]">{{ JSON.stringify(latest[t].detail, null, 2) }}</pre>
        </div>
      </div>

      <a-button block style="margin-top:16px" @click="refresh(['all'])">全部刷新</a-button>

      <a-divider>检测历史</a-divider>
      <history-timeline :domain-id="row.id" :key="historyKey" />
    </template>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import HealthTag from './components/HealthTag.vue'
import HistoryTimeline from './HistoryTimeline.vue'
import { checkDomain, updateDomain, fetchChecks } from '@/api/admin-domains'

export default {
  name: 'DetailDrawer',
  components: { HealthTag, HistoryTimeline },
  data() {
    return {
      visible: false,
      row: null,
      form: { owner_user_id: '', registrar_source: 'manual', remark: '', active: true, _expiryDate: null },
      latest: {},
      checkTypes: ['dns', 'cert', 'vt', 'whois'],
      historyKey: 0,
    }
  },
  methods: {
    async open(row) {
      this.row = row
      this.form.owner_user_id = row.owner_user_id != null ? String(row.owner_user_id) : ''
      this.form.registrar_source = row.registrar_source || 'manual'
      this.form.remark = row.remark || ''
      this.form.active = !!row.active
      this.form._expiryDate = row.registrar_expires_at ? moment(row.registrar_expires_at * 1000) : null
      this.latest = {}
      this.visible = true
      await this.loadLatest()
    },
    async loadLatest() {
      try {
        const r = await fetchChecks(this.row.id, '', 20)
        const root = r && r.data ? r.data : r
        const items = (root && root.items) || []
        const map = {}
        for (const c of items) { if (!map[c.check_type]) map[c.check_type] = c }
        this.latest = map
      } catch (e) {
        console.warn('loadLatest fail', e)
      }
    },
    async refresh(types) {
      this.$message.loading({ content: '检测中...', key: 'd' })
      try {
        await checkDomain(this.row.id, types)
        this.$message.success({ content: '完成', key: 'd' })
        await this.loadLatest()
        this.historyKey++
        this.$emit('saved')
      } catch (e) {
        this.$message.error({ content: '失败: ' + ((e && e.message) || e), key: 'd' })
      }
    },
    async save() {
      const payload = {
        id: this.row.id,
        owner_user_id: this.form.owner_user_id === '' ? null : Number(this.form.owner_user_id),
        registrar_expires_at: this.form._expiryDate ? this.form._expiryDate.unix() : null,
        registrar_source: this.form.registrar_source,
        remark: this.form.remark,
        active: this.form.active ? 1 : 0,
      }
      try {
        await updateDomain(payload)
        this.$message.success('已保存')
        this.$emit('saved')
      } catch (e) {
        this.$message.error('保存失败: ' + ((e && e.message) || e))
      }
    },
  },
}
</script>

<style scoped>
.checks-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.check-card { padding: 12px; border: 1px solid #eee; border-radius: 4px; }
.check-card .hdr { display: flex; justify-content: space-between; margin-bottom: 8px; }
.check-card pre { font-size: 11px; max-height: 100px; overflow: auto; background: #fafafa; padding: 4px; }
</style>
